import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";
import { Input } from "../ui/input";
import { Loader2, Plus } from "lucide-react";
import { toast } from "sonner";
import { useDashboard } from "../../context/DashboardContext";

const SUGGESTIONS = ["ETHUSDT", "SOLUSDT", "BNBUSDT", "XRPUSDT", "DOGEUSDT", "AVAXUSDT", "LINKUSDT", "SUIUSDT"];

export default function AddPairDialog({ open, onOpenChange }) {
  const { addPair } = useDashboard();
  const [symbol, setSymbol] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (raw) => {
    const val = (raw || symbol).trim().toUpperCase();
    if (!val) return;
    setLoading(true);
    try {
      const created = await addPair(val);
      toast.success(`${created.base}/USDT added — live on ${"provider"}`);
      setSymbol("");
      onOpenChange(false);
    } catch (e) {
      const msg = e?.response?.data?.detail || "Pair not available on any provider";
      toast.error(msg);
    } finally { setLoading(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md" style={{ background: "var(--panel)", border: "1px solid var(--border)", color: "var(--text)" }}>
        <DialogHeader>
          <DialogTitle className="text-[16px]">Add Favorite Pair</DialogTitle>
          <DialogDescription style={{ color: "var(--text-muted)" }}>
            Enter a symbol (e.g. ETH or ETHUSDT). We verify it's live on a connected provider before adding — pairs are never faked.
          </DialogDescription>
        </DialogHeader>

        <div className="flex gap-2 mt-1">
          <Input
            autoFocus value={symbol} placeholder="ETHUSDT"
            onChange={(e) => setSymbol(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && submit()}
            style={{ background: "var(--panel-2)", border: "1px solid var(--border)", color: "var(--text)" }}
          />
          <button onClick={() => submit()} disabled={loading}
            className="flex items-center gap-1.5 rounded-lg px-4 text-[13px] font-semibold ym-hover"
            style={{ background: "linear-gradient(135deg,#8b5cf6,#7c3aed)", color: "#fff" }}>
            {loading ? <Loader2 size={15} className="animate-spin" /> : <Plus size={15} />} Add
          </button>
        </div>

        <div className="mt-3">
          <div className="text-[10px] font-semibold tracking-wide mb-2" style={{ color: "var(--text-dim)" }}>POPULAR</div>
          <div className="flex flex-wrap gap-1.5">
            {SUGGESTIONS.map((s) => (
              <button key={s} onClick={() => submit(s)} disabled={loading}
                className="pill ym-hover" style={{ background: "var(--panel-2)", borderColor: "var(--border)", color: "var(--text-muted)" }}>
                {s.replace("USDT", "")}
              </button>
            ))}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
